import { RadvPageWrapper } from "@ca-dmv-radv/components";
import {
  APPLICATION_TYPE,
  mobileSessionDynamic,
  getApplicationData,
  getGettingStartedStatus,
} from "@ca-dmv-radv/data";
import { useTranslation } from "@ca-dmv-radv/translation";
import { getParamUrl } from "@ca-dmv-radv/utilities";
import { Button, BUTTON_STYLE_LINK, ButtonWrapper } from "@ca-dmv/core";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { isFirefox, isMobile } from "react-device-detect";

import { generateErrorUrl } from "../dashboard/PresenceVerification/constants";

export default function DynamicMobileSession({ title, applicationType }) {
  const { t } = useTranslation();
  const formProps = { isForm: false };
  const params = useParams();
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleExpiredTokenNavigation = (token, allowRequestLink) => {
    const expiredUrl = `/${applicationType}/expired`;
    navigate(expiredUrl, {
      state: {
        token,
        allowRequestLink,
      },
    });
  };
  useEffect(() => {
    setLoading(true);

    (async () => {
      const aidUnsupported = isFirefox;

      const isNchOrRnc =
        applicationType === APPLICATION_TYPE.NCH ||
        applicationType === APPLICATION_TYPE.RNC;

      if (!isNchOrRnc) {
        if (!isMobile || aidUnsupported) {
          navigate(`/${applicationType}/error`, {
            state: {
              applicationType,
              isMobile,
              supported: !aidUnsupported,
            },
          });
          return;
        }
      }

      if (isMobile || isNchOrRnc) {
        await (async () => {
          let success;
          let message;
          let data;
          try {
            ({ success, message, data } = await mobileSessionDynamic(
              params.token,
              applicationType
            ));
            if (success === true) {
              let isPvDependency = false;
              let isGettingStartedCompleted = false;
              try {
                const applicationDataResponse = await getApplicationData(
                  applicationType
                );
                isPvDependency = applicationDataResponse?.pvDependency;
              } catch (e) {
                // Ignore missing application data error as an explicit default logic condition.
              }

              try {
                const gettingStartedResponse = await getGettingStartedStatus(
                  applicationType
                );
                // Assume success response contains boolean data flag for completion
                if (gettingStartedResponse?.success === true) {
                  isGettingStartedCompleted =
                    gettingStartedResponse.data.gettingStarted === true;
                }
              } catch (e) {
                console.error("Failed to fetch gettingStarted status", e);
              }

              setLoading(false);
              if (
                applicationType === APPLICATION_TYPE.NCH ||
                applicationType === APPLICATION_TYPE.RNC
              ) {
                window.location.href = `/${applicationType}/`;
              } else if (isGettingStartedCompleted) {
                window.location.href = `${getParamUrl(
                  `/${applicationType}/getStarted`,
                  params
                )}?isPvDependency=${isPvDependency}`;
              } else if (!isPvDependency) {
                window.location.href = getParamUrl(
                  `/${applicationType}/presence-verification`,
                  params
                );
              } else {
                window.location.href = getParamUrl(
                  `/${applicationType}/document-upload`,
                  params
                );
              }
            } else if (message === "INVALID_TOKEN") {
              handleExpiredTokenNavigation(data?.token, data?.allowRequestLink);
            }
          } catch (error) {
            setLoading(false);
            if (error.response) {
              setErrorMessage(error.response?.data?.data?.error);
            }
            const url = generateErrorUrl(error, applicationType);

            if (
              error.response?.status === 401 ||
              error.response?.status === 422
            ) {
              navigate(url, {
                state: {
                  token: error.response?.data?.data?.token,
                  status: error.response.status,
                },
              });
            } else {
              navigate(url);
            }
          }
        })();
      }
    })();
  }, []);

  return (
    <RadvPageWrapper
      fullWidth
      formProps={formProps}
      showRequiredFieldSeparator={false}
      pageTitle={title}
    >
      {loading && <>Loading.....</>}
      <div className="flex flex--col flex--align-center">
        {!loading && errorMessage && (
          <>
            <h2 className="h3 text--xmd bp-sm:text--med bp-md:text--xlg text--700 text--center mb-24 bp-md:mb-48">
              {t("screens-error-heading", "Oops, something went wrong")}
            </h2>
            <p className="text--sm mb-0 text--center max-width--400">
              {errorMessage}
            </p>
          </>
        )}
        {!loading && errorMessage && (
          <ButtonWrapper wrapperClass="flex--col-reverse mt-40 bp-md:mt-60">
            <Button
              label={t(
                "screens-Timeout-buttonLabel-ReturnToDMVHomePage",
                "Return to the DMV Homepage"
              )}
              btnStyle={BUTTON_STYLE_LINK}
              buttonClass="mb-0 bp-md:mr-40"
              onClick={() => {
                window.location = process.env.REACT_APP_PORTAL_URL;
              }}
            />
            <Button
              buttonClass="mb-40 bp-md:mb-0"
              label={t(
                "screens-Timeout-buttonLabel-ReturnToApplication",
                "Return to Application"
              )}
              onClick={() => {
                window.location = process.env.REACT_APP_EDL_URL;
              }}
            />
          </ButtonWrapper>
        )}
      </div>
    </RadvPageWrapper>
  );
}
